import { AxiosResponse } from 'axios';
import { instance } from './private';
import { TokenSaleStats } from '../types/dto/TokenStats.dto';

export const getTokenSaleStats = (): Promise<AxiosResponse<TokenSaleStats>> => instance.get('/v1/token-sale/stats');
